import { useState, useEffect } from "react";

interface Status {
  connected: boolean;
  realm_id: string | null;
}

export function App() {
  const [status, setStatus] = useState<Status | null>(null);

  useEffect(() => {
    fetch("/api/status")
      .then((r) => r.json())
      .then(setStatus);
  }, []);

  return (
    <div className="container">
      <nav>
        <a href="/">QBrain</a>
        <a href="/terms">Terms</a>
        <a href="/privacy">Privacy</a>
      </nav>

      <h1>QBrain</h1>
      <p className="subtle">Internal accounting tools for Drop Mobility.</p>

      <h2>QuickBooks Connection</h2>
      {status === null ? (
        <p>Loading...</p>
      ) : status.connected ? (
        <p className="success">Connected to QuickBooks (Realm: {status.realm_id})</p>
      ) : (
        <div>
          <p>Not connected.</p>
          <a className="btn" href="/auth/quickbooks">Connect to QuickBooks</a>
        </div>
      )}
    </div>
  );
}
